import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainWeaver.css';
import Header from './../js/header.js';
import $ from 'jquery';
import axiosInstance from '../api/csAxios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 

var querystring=require('querystring');
var lstWeaver=[];
var lstStaff=[];
var lstCity=[];
var lstMachineType=[];
var lstLocalMachine=[];
var flag = true;
var httpURL = '';

class MaintainWeaver extends Component {
	constructor(props){
		super(props);
		this.state={
			machineType	: [],
			staff		: [],
			weaver 	: [],
			city		: [],
			count		: '',
			width		: '97.5%',
			loader	: 'none',
			opacity	: 1,
			}
	}
	
	filterFunc=()=>{
		$("#name, #phone, #mail, #city , #staff").on("keyup", ()=>{
			this.setWeaverTable();
			$("#weaverAddForm")[0].reset();
			this.setMachineTable(lstMachineType);
		});
	}
	
	machineCountChange=(e)=>{
	    this.setState({count:e.target.value});
	}
	
	handlePopupSave=()=>{
		var mcType = $('#machineCmb').find('option:selected').text();
		var mcTypeId=$('#machineCmb').find('option:selected').val();
		var capacity=$('#capacity').val();
		var table = document.getElementById('machineTable');
		var tbody = document.getElementById('machineTableBody');
		var count = this.state.count;
		
		if(mcTypeId == 0){
			toast.warning('Please select Machine Type');
			return false;
		}
		if(count == ''){
			toast.warning('Please fill capacity');
			return false;
		}
		
		var x = this.checkExist(lstLocalMachine, mcTypeId);
		if(x != -1){
			lstLocalMachine[x].count = count;
		}else{
			lstLocalMachine.push({'machineTypeId': mcTypeId, 'machineType': mcType, 'capacity': capacity, 'count':count});
		}
		this.setMachineTable(lstLocalMachine);
		this.closePoPup();
	}
	
	checkExist(lstLocalMachine, mcTypeId){
		for(var i=0; i<lstLocalMachine.length; i++){
			if(lstLocalMachine[i].machineTypeId == mcTypeId){
				return i;
			}
		}
		return -1;
	}
	
	handleSave=(e)=>{
		var lstMachine=[];
		$('#machineTableBody tr').each(function (i, e) { 
			var id = $(this).find('td:eq(0)').text();
			var mcType=$(this).find('td:eq(1)').text();
			var capacity=$(this).find('td:eq(2)').text();
			var count = $(this).find('td:eq(3)').text();
			var selected = $(e).find('input[type="checkbox"]').prop('checked') == true ? 1 : 0;
			lstMachine.push({'machineTypeId':id, 'machineType':mcType, 'capacity':capacity, 'count':count, 'selected':selected});
		});
		var weaver=$('#nameInput').val();
		var phoneNo=$('#phoneInput').val();
		var eMail=$('#email').val();
		var cityId=$('#cityCmb').find("option:selected").val();
		var city=$('#cityCmb').find("option:selected").text();
		var bufferDays=$('#bufferInput').val();
		var staffId=$('#staffCmb').find("option:selected").val();
		var staff=$('#staffCmb').find("option:selected").text();
		var blocked= $('#inputBlocked').prop('checked') == true ? 1 : 0;
	    
		if(weaver == ''){
			toast.warning('Please fill weaver name');
			document.getElementById('nameInput').focus();
			return false;
		}
		
		if(phoneNo == ''){
			toast.warning('Please fill weaver phone number');
			document.getElementById('phoneInput').focus();
			return false;
		}
		
		if(phoneNo.length != 10){
			toast.warning('Phone number should be 10 digits only');
			document.getElementById('phoneInput').focus();
			return false;
		}
		
		if(isNaN(phoneNo)){
			toast.warning('Phone number should be numeric');
			document.getElementById('phoneInput').focus();
			return false;
		}
		
		if(eMail == ''){
			toast.warning('Please fill weaver E-Mail');
			document.getElementById('email').focus();
			return false;
		}else{
			var result = this.validateEmail(eMail);
			if(result == false){
				toast.warning("Invalid Email");
				document.getElementById("email").focus();
				return false;
			}
		}
		
		if(bufferDays == ''){
			toast.warning('Please fill buffer days');
			document.getElementById('bufferInput').focus();
			return false;
		}
		
		if(isNaN(bufferDays)){
			toast.warning('Buffer days should be numeric');
			document.getElementById('bufferInput').focus();
			return false;
		}
		
		if(cityId == 0){
			toast.warning('Please select city');
			document.getElementById('cityCmb').focus();
			return false;
		}
		
		if(staffId == 0){
			toast.warning('Please select staff');
			document.getElementById('staffCmb').focus();
			return false;
		}
		var counts = 0;
		for(var i=0; i<lstMachine.length; i++){
			counts = counts+lstMachine[i].selected;
			if(lstMachine[i].selected == 1 && lstMachine[i].count == 0){
				toast.warning('The value of count can not be 0');
				return false;
			}
		}

		if(counts == 0){
			toast.warning('Please select atleast one machine');
			return false;
		}

		if(flag == true){
			let weaverId = 0;
		    var weaver={weaverId, weaver, phoneNo, eMail, cityId, bufferDays, staffId, blocked, lstMachine}
			this.setState({loader:'block', opacity:0.5});
			axiosInstance.post(httpURL+'/a/mst/wvr/save', 
				querystring.stringify({'weaver':JSON.stringify(weaver)}), {withCredentials:true}
			).then((res) =>{
				if(res.data.SvcStatus === 'Success'){
					toast.success(res.data.SvcMsg);
					flag = false;
					weaver.weaverId = res.data.weaverId;
					weaver.city = city;
					weaver.staff = staff;
					lstWeaver.push(weaver);
					this.setWeaverTable();
					this.setWeaverForm(res.data.weaverId);
					this.highlightRow('weaverTableBody', res.data.weaverId);
					$('#generatePassword').show();
					//this.clickAdd();
				}else{
					toast.error(res.data.SvcMsg);
				}
				this.setState({loader:'none', opacity:1});
			}).catch((e)=>{
				toast.error('Service failed: '+e);
			});
		}else{
			let weaverId = $('#weaverTableBody tr.selected').find('td:eq(0)').text();
			
			if(weaverId == ''){
				toast.warning('Please select row');
				return false;
			}
			
			var weaver={weaverId, weaver, phoneNo, eMail, cityId, bufferDays, staffId, blocked, lstMachine}
			this.setState({loader:'block', opacity:0.5});
			axiosInstance.post(httpURL+'/a/mst/wvr/save',
				querystring.stringify({'weaver':JSON.stringify(weaver)}), {withCredentials:true}
			).then((res) =>{
				if(res.data.SvcStatus === 'Success'){
					toast.success(res.data.SvcMsg);
					weaver.city = city;
					weaver.staff = staff;
					var weaverIndex = this.getWeaverIndex(weaverId);
					lstWeaver.splice(weaverIndex,1,weaver);
					this.setWeaverTable();
					this.setWeaverForm(weaverId);
					this.highlightRow('weaverTableBody', weaverId);
				}else{
					toast.error(res.data.SvcMsg);
				}
				this.setState({loader:'none', opacity:1});
			}).catch((e)=>{
				toast.error('Service failed: '+e);
			});
	   }
	} 
	
	getWeaverIndex(weaverId){
		for(var i=0; i<lstWeaver.length; i++){
			if(lstWeaver[i].weaverId == weaverId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var weaverId = $(this).find('td:eq(0)').text();
			if(weaverId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}
	
	validateEmail(x){
		var atpos = x.indexOf("@");
		var dotpos = x.lastIndexOf(".");
		if (atpos<1 || dotpos<atpos+2 || dotpos+2>=x.length) {
			return false;
		}else{
			return true;
		}
	}
	
	generatePassword=()=>{
	  var weaverId = $('#weaverTableBody tr.selected').find('td:eq(0)').text(); 
	  var emailId  = $('#weaverTableBody tr.selected').find('td:eq(3)').text();
		if(weaverId == ''){
			toast.warning('Please select weaver');
			return false; 
		}
		this.setState({loader:'block', opacity:0.5});
	  axiosInstance.post(httpURL+'/a/mst/wvr/generatepassword',
			querystring.stringify({'weaverId':weaverId,'emailId':emailId}), {withCredentials:true}
		).then((res) =>{
			if(res.data.SvcStatus === 'Success'){
				toast.success(res.data.SvcMsg);
			}else{
				toast.error(res.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
	}
	
	clickAdd=(e)=>{
		flag = true;
		$( "#email" ).removeAttr( "disabled", "disabled" );
		$("#weaverAddForm")[0].reset();
		this.setMachineTable(lstMachineType);
		$('#generatePassword').hide();
		//$('#machineTableBody tr').remove();
	}
	
	componentDidMount(){
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.get(httpURL+'/a/mst/cty/list', {withCredentials:true})
		 .then((response) =>{
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					city : response.data.lstCity,
				});				
				lstCity	= this.state.city;
				this.fillCityCmb();
			}else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
		
		axiosInstance.get(httpURL+'/a/mst/stf/list', {withCredentials:true})
		 .then((res) =>{
			if(res.data.SvcStatus === 'Success'){
				this.setState({
					staff : res.data.lstStaff,
				});				
				lstStaff = this.state.staff;
				this.fillStaffCmb();
			}else{
				toast.error(res.data.SvcMsg);
			}
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
		
		axiosInstance.get(httpURL+'/a/mst/mty/list', {withCredentials:true})
		 .then((res) =>{
			if(res.data.SvcStatus === 'Success'){
				this.setState({
					machineType : res.data.lstMachineType,
				});				
				lstMachineType	= this.state.machineType;
				this.fillMachineCmb();
				for(var i=0; i<lstMachineType.length; i++){
					lstMachineType[i].count = 0;
					lstMachineType[i].selected = 0;
				}
				this.setMachineTable(lstMachineType);
			}else{
				toast.error(res.data.SvcMsg);
			}
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
		
		axiosInstance.get(httpURL+'/a/mst/wvr/list', {withCredentials:true})
		 .then((res) =>{
			if(res.data.SvcStatus === 'Success'){
				this.setState({
					weaver	  	: res.data.lstWeaver,
				});				
				lstWeaver		= this.state.weaver;
				this.setWeaverTable();
			}else{
				toast.error(res.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}
	
	handleResize=()=>{
		var width = ($('.tableLayout1').parent().width())-18;
		this.setState({width:width})
	}
	
	setWeaverTable=()=>{
		$('#weaverTableBody tr').remove();
		var table = document.getElementById('weaverTable');
		var tbody = document.getElementById('weaverTableBody');
		var filterName = $("#name").val().toLowerCase();
		var filterPhone = $("#phone").val();
		var filterMail = $("#mail").val().toLowerCase();
		var filterCity = $("#city").val().toLowerCase();
		var filterStaff = $("#staff").val().toLowerCase();
		
		for(var i=0; i<lstWeaver.length; i++){
			var weaverId	= lstWeaver[i].weaverId;
			var weaverName 	= lstWeaver[i].weaver;
			var phoneNo		= lstWeaver[i].phoneNo;
			var weaverEmail	= lstWeaver[i].eMail;
			var cityId		= lstWeaver[i].cityId;
			var city		= lstWeaver[i].city;
			var staffId		= lstWeaver[i].staffId;
			var staffName	= lstWeaver[i].staff;
			var row = document.createElement('tr');
			row.onclick=(e)=>{
				flag = false;
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				var weaverId = $(e.target).closest('tr').find('td:eq(0)').text();
				this.setWeaverForm(weaverId);
				$('#generatePassword').show();
			}
			
			if(weaverName.toLowerCase().indexOf(filterName) == -1)
				continue;
			if(phoneNo.indexOf(filterPhone) == -1)
				continue;
			if(weaverEmail.toLowerCase().indexOf(filterMail) == -1)
				continue;
			if(city.toLowerCase().indexOf(filterCity) == -1)
				continue;
			if(staffName.toLowerCase().indexOf(filterStaff) == -1)
				continue;
			
			this.addTD(row, weaverId, 'no-display');
			this.addTD(row, weaverName, '');
			this.addTD(row, phoneNo, '');
			this.addTD(row, weaverEmail, '');
			this.addTD(row, city, '');
			this.addTD(row, staffName, '');
			this.addTD(row, staffId, 'no-display');
	     	
			tbody.append(row);
		}
		table.append(tbody);	
	}  

	addTD(row, val, classname){
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}

	closePoPup=(e)=>{
		$('.onaddPopup').hide();
		$('.main').removeClass('addOpacity');
        $('#machineCmb').val(0);
		$('#countid').val('');
	}
	
	fillStaffCmb =()=>{
		$('#staffCmb').empty();
		$('#staffCmb').prepend($("<option> </option>").val(0).html('Staff'));
		for(var i=0; i<lstStaff.length; i++){
			var staffId 	= lstStaff[i].staffId;
			var staffName  	= lstStaff[i].staff;
			$('#staffCmb').append($("<option> </option>").val(staffId).html(staffName)); 
		}
	}
	
	fillCityCmb =()=>{
		$('#cityCmb').empty();
		$('#cityCmb').prepend($("<option> </option>").val(0).html('City'));
		for(var i=0; i<lstCity.length; i++){
			var cityId 	= lstCity[i].cityId;
			var city  	= lstCity[i].city;
			$('#cityCmb').append($("<option> </option>").val(cityId).html(city)); 
		}
	}
	
	fillMachineCmb=()=>{
		$('#machineCmb').empty();
		$('#machineCmb').prepend($("<option> </option>").val(0).html('Machine Type'));
		for(var i=0; i<lstMachineType.length; i++){
	   		var machineTypeId 	= lstMachineType[i].machineTypeId;
	   		var machineType 	= lstMachineType[i].machineType;
	   		$('#machineCmb').append($("<option> </option>").val(machineTypeId).html(machineType)); 
   		}   	
	}
	
	setWeaverForm=(id)=>{
		$( "#email" ).prop( "disabled", true );
		var weaverData = this.getWeaverData(id);
		if(weaverData != -1){
			$('#nameInput').val(weaverData.weaver);
			$('#phoneInput').val(weaverData.phoneNo);
			$('#email').val(weaverData.eMail);
			$('#bufferInput').val(weaverData.bufferDays);
			$('#cityCmb').val(weaverData.cityId);
			$('#staffCmb').val(weaverData.staffId);
			$('#inputBlocked').prop('checked', weaverData.blocked);
			this.setMachineTable(weaverData.lstMachine);
		}
	}
	
	getWeaverData(id){
		for(var i=0; i<lstWeaver.length; i++){
			if(lstWeaver[i].weaverId == id){
			   return lstWeaver[i];
			}
		}
		return -1;
	}
	
	setMachineTable=(lstMachine)=>{
		$('#machineTableBody tr').remove();
		var table = document.getElementById('machineTable');
		var tbody = document.getElementById('machineTableBody');
	 
		for(var i=0; i<lstMachine.length; i++){
			var mcTypeId 	= lstMachine[i].machineTypeId;
			var mcType 		= lstMachine[i].machineType;
			var capacity 	= lstMachine[i].capacity;
			var count 		= lstMachine[i].count;
			var selected 	= lstMachine[i].selected;
	 
			var row = document.createElement('tr');
		    
			this.addTD(row, mcTypeId, 'no-display');
			this.addTD(row, mcType, '');
			this.addTD(row, capacity, '');
			this.addTD(row, count, '');
			this.addTDCbx(row, 'cbx'+mcTypeId, selected, 'text-center');
			
			tbody.append(row);
		 } 
		 table.append(tbody);
	}
	
	addTDCbx(row, val, flg, classname){  
		var cell = document.createElement('td');
		var cbx  = document.createElement('input');
		cbx.type = 'checkbox';	
		cbx.id = val;
		
		cbx.onclick=(e)=>{
			e.stopPropagation();
		}
		
		if(flg == 1){
			$(cbx).attr('checked', true);
		}else{
			$(cbx).attr('checked', false);
		}
		row.onclick=(e)=>{    
			lstLocalMachine=[];
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			var capacityvalue=$(e.target).closest('tr').find('td:eq(2)').text();
			var countvalue=$(e.target).closest('tr').find('td:eq(3)').text();
			$('.onaddPopup').show();
			$('.main').addClass('addOpacity');
			$('#machineCmb').val($(e.target).closest('tr').find('td:eq(0)').text());
			$('#capacity').val(capacityvalue);
			$('#count').val(countvalue);
			$('#machineTableBody tr').each((i, e)=>{
				var mcId = $(e).find('td:eq(0)').text();
				var mcType = $(e).find('td:eq(1)').text();
				var capacity = $(e).find('td:eq(2)').text();
				var count = $(e).find('td:eq(3)').text();
				var selected = $(e).find('input[type="checkbox"]').prop('checked') == true ? 1 : 0;
				lstLocalMachine.push({'machineTypeId': mcId, 'machineType': mcType, 'capacity':capacity, 'count':count, 'selected':selected});
			});
		}
		cell.className = classname;
		cell.append(cbx);
		row.append(cell);
	}
	
  render(){
	httpURL = window.httpURL;  
    return (
	        <div style={{height:'100%'}}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
					<img src={require("../images/loader.gif")} alt="Loader..."/>
				</div> 
				<div className="main" style={{opacity:this.state.opacity}}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<div className="col-sm-6 col-xs-11 padding-remove">
								<table className="tableLayout1" style={{width:this.state.width}}>
									<thead>
										<tr>
											<th style={{width:5, display:'none'}}> Weaver Id</th>
											<th style={{width:100}}><input type="text" className="form-control inp-search" id="name" placeholder="Weaver Name" onChange={this.filterFunc}/></th>
											<th style={{width:85}}><input type="text" className="form-control inp-search" id="phone" placeholder="Phone" onChange={this.filterFunc}/></th>
											<th style={{width:200}}><input type="text" className="form-control inp-search" id="mail" placeholder="E-Mail" onChange={this.filterFunc}/></th>
											<th style={{width:100}}><input type="text" className="form-control inp-search" id="city" placeholder="City" onChange={this.filterFunc}/></th>
											<th style={{width:100}}><input type="text" className="form-control inp-search" id="staff" placeholder="Staff Name" onChange={this.filterFunc}/></th>
											<th style={{width:5, display:'none'}}>Staff Id</th>
										</tr>
									</thead>
								</table>
								<div className="weaverTableDiv col-sm-12 col-xs-11 padding-remove">
									<table id="weaverTable" className="tableLayout">
										<colgroup>
											<col width="100" />
											<col width="85" />
											<col width="200" />
											<col width="100" />
											<col width="100" />
										</colgroup>
										<tbody id="weaverTableBody">
										</tbody>
									</table>
								</div>
							</div>
							<div className="col-sm-1 col-xs-1" onClick={this.clickAdd}>
								<span id="addWeaver" title="Add Weaver" className="addIcon glyphicon glyphicon-plus-sign"></span>
							</div>
							<div className="col-sm-5 col-xs-12 padding-remove">
								<form id="weaverAddForm" className="form-horizontal">
									<div className="form-group">
										<label className="control-label col-sm-4">Name:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<input type="text" className="form-control padding-left:2px;" placeholder="Name" id="nameInput" />
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-4">Phone:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<input type="text"  maxLength="10"  className="form-control" placeholder="Phone" id="phoneInput" />
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-4">E-Mail:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<input type="text" className="form-control" placeholder="E-Mail" id="email" />
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-4">Buffer Days:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<input type="text" className="form-control" placeholder="Buffer Days" id="bufferInput" />
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-4">City:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<select className="form-control" id="cityCmb" ></select>
										</div>
									</div>              
									
									<div className="form-group">
										<label className="control-label col-sm-4">Staff:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<select className="form-control" id="staffCmb" ></select>
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-4">Blocked:</label>
										<div className="col-sm-8">
											<div className="checkbox">
												<input type="checkbox" id="inputBlocked" style={{marginTop:0}} />
											</div>
										</div>
									</div>   									
									<div className="form-group">
										<label className="control-label col-sm-4">Machine Type:<span style={{color:"red"}}>*</span></label>
										<div className="col-sm-8">
											<div className="machineTableDiv col-sm-12 padding-remove">
												<table id="machineTable" style={{width:'100%', fontSize:10}}>
													<thead>
														<tr>
															<th style={{width:150}}>Machine Type</th>
															<th style={{width:100}}>Capacity</th>
															<th style={{width:100}}>Count</th>
															<th style={{width:100}}>Select</th>
														</tr>
													</thead>
													<tbody id="machineTableBody">
													</tbody>
												</table>
											</div>
										</div>
									</div>
									<div className="form-group" style={{marginTop:20}}>
										<div className="col-sm-12 text-center">
											<button type="button" className="btn btn-warning" onClick={this.handleSave}>Save</button>
											<button style={{marginLeft:10, display:'none'}} type="button" id="generatePassword" className="btn btn-warning" onClick={this.generatePassword}>Generate Password</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
				<div className="onaddPopup">
					<div className="closeBtn" onClick={this.closePoPup.bind(this)}>
						<span style={{position:'absolute', color:'#fff', top:'18px', left:'18px'}} className="glyphicon glyphicon-remove">
						</span>
					</div>
					<div style={{width:'100%', height:'100%'}}>
						<form className="form-horizontal">
							<div className="form-group">
								<label className="control-label col-sm-5">Machine Type:</label>
								<div className="col-sm-7">
									<select className="form-control" id="machineCmb" onChange={this.machineSelectChange}></select>
								</div>
							</div>
							<div className="form-group">
								<label className="control-label col-sm-5">Capacity:</label>
								<div className="col-sm-7">
									<input type="text" className="form-control" id="capacity" placeholder="Capacity" readOnly  />
								</div>
							</div>
							
							<div className="form-group">
								<label className="control-label col-sm-5">Count:</label>
								<div className="col-sm-7">
									<input type="text" className="form-control" id="count" placeholder="Count" onChange={this.machineCountChange} />
								</div>
							</div>
							<div className="form-group" style={{marginTop:50}}>
								<div className="col-sm-12 text-center">
									<button type="button" className="btn btn-warning" onClick={this.handlePopupSave}>Save</button>
								</div>
							</div>
						</form>
					</div>
				</div>
		    </div>
		);
	}
}
export default MaintainWeaver;
